import { render, staticRenderFns } from "./SectionAssetDetail.vue?vue&type=template&id=db0e47f2"
import script from "./SectionAssetDetail.vue?vue&type=script&lang=js"
export * from "./SectionAssetDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports